import { render, staticRenderFns } from "./Seminar.vue?vue&type=template&id=362252fa&scoped=true&"
import script from "./Seminar.vue?vue&type=script&lang=js&"
export * from "./Seminar.vue?vue&type=script&lang=js&"
import style0 from "./Seminar.vue?vue&type=style&index=0&id=362252fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362252fa",
  null
  
)

export default component.exports